import StartpageElement from '@/Controls/StartpageElement';
import StartpageElementViewModelType from '@/ViewModels/Controls/StartpageElementViewModel';
import ControlViewModel from '@/ViewModels/ControlViewModel';

export default abstract class CustomStartpageElement extends StartpageElement {
    constructor(viewModel: StartpageElementViewModelType, element: JQuery, protected customViewModel: ControlViewModel) {
        super(viewModel, element);
    }

    protected abstract getContent(): JQuery<HTMLElement>;

    protected onWidgetCreatedCallback(widget: null): void {
        super.onWidgetCreatedCallback(widget);

        const $content = this.getContent();
        this.jQueryControl.append($content);
    }
}